var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',[_c('div',{staticClass:"text-center"},[_c('vuetify-logo')],1),_c('div',{staticClass:"checkout-section section"},[_c('checkout')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }